/**
 * Portal fetch utility for domain normalization
 * 
 */
import { PROD_DOMAIN_PRIMARY, PROD_DOMAIN_SECONDARY } from '../data/Data';
let activeDomain = PROD_DOMAIN_PRIMARY;
export function setActiveDomain(domain) {
  activeDomain = domain;
}
export function getActiveDomain() {
  return activeDomain;
}
export async function portalFetch(url, options) {
  const resolved = url.replace(PROD_DOMAIN_PRIMARY, activeDomain).replace(PROD_DOMAIN_SECONDARY, activeDomain);
  return fetch(resolved, options);
}
export async function checkDomainAtStartup() {
  if (activeDomain !== PROD_DOMAIN_PRIMARY) {
    return;
  }
  const HEALTH_CHECK_TIMEOUT_MS = 5000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), HEALTH_CHECK_TIMEOUT_MS);
  try {
    await fetch(`https://${PROD_DOMAIN_PRIMARY}/.server/trace`, {
      mode: 'no-cors',
      signal: controller.signal
    });
  } catch (err) {
    try {
      await fetch(`https://${PROD_DOMAIN_SECONDARY}/.server/trace`, {
        mode: 'no-cors',
        signal: controller.signal
      });
      setActiveDomain(PROD_DOMAIN_SECONDARY);
    } catch (secondaryErr) {
      // Both domains failed, keep primary as default
    }
  } finally {
    clearTimeout(timeoutId);
  }
}